import React from 'react';

import { TypographyH2, TypographyP } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';

const JobDetailsStepHeader = (): React.JSX.Element => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 py-5">
            <TypographyH2 className="text-foreground">{UIStrings.ProvideKeyJobDetails}</TypographyH2>
            <TypographyP className="text-foreground max-w-3xl text-center">
                {UIStrings.QuickSummaryCreateStep}
            </TypographyP>
        </div>
    );
};

export default JobDetailsStepHeader;
